import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Utilities } from '@app/core/utils/utilities';
import { ERQualType } from '@app/shared/enm/entry-requirement.enum';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErService {
  httpClient = inject(HttpClient);
  util = inject(Utilities);
  erQualType = ERQualType;

  getEntryRequirementData(institutionId: any, pageNo: number, paramsValues: any, filterDetails?: Map<string, string>, type?: string) {
    const erUrl = apiEndpointURL.getInstitutionEndpoint + '/' + institutionId + '/detaileders/' + type;
    let params = new HttpParams().set('pageSize', this.util.recordsPerPage()).set('pageNumber', pageNo);
    if (filterDetails && filterDetails.size)
      filterDetails.forEach((value: any, key) => {
        if (key === 'erTestAccepted')
          paramsValues = { ...paramsValues, ...value };
        else
          params = params.set(key, value);
      });
    Object.keys(paramsValues).forEach((key) => {
      if (paramsValues[key])
        params = params.set(key, paramsValues[key]);
    });
    return this.httpClient.get(erUrl, { params });
  }

  getERRefData() {
    return this.httpClient.get(apiEndpointURL.erReferenceEndpoint);
  }

  getERJson(erTypeId: any) {
    const params = new HttpParams().set('headerNotRequired', true);
    if (erTypeId === this.erQualType.Qualification)
      return this.httpClient.get<any>(apiEndpointURL.erQualFieldJson, { params });
    else if (erTypeId == this.erQualType.Tests)
      return this.httpClient.get<any>(apiEndpointURL.erTestFieldJson, { params });
    return of(null);
  }

  createER(detailsToSave: any, erType: string) {
    return this.httpClient.post([apiEndpointURL.getInstitutionEndpoint, JSON.parse(this.util.institutionDetails())?.institutionId, 'detaileders', erType].join('/'), detailsToSave);
  }

  getERDetails(erType: any, erEntityId: any, from?: any) {
    let params = new HttpParams();
    if (from === 'resolver') params = params.set('resolver', 'true');
    const erDetailsUrl = [apiEndpointURL.getInstitutionEndpoint, 'detaileders', erType, erEntityId].join('/');
    return this.httpClient.get(erDetailsUrl, { params });
  }

  updateER(detailsToSave: any, erType: string, entityId: any) {
    return this.httpClient.put([apiEndpointURL.getInstitutionEndpoint, 'detaileders', erType, entityId].join('/'), detailsToSave);
  }

  saveAssignEr(institutionId: any, courseInstanceId: any, assignERList: any) {
    const erAssignUrl = `${apiEndpointURL.getInstitutionEndpoint}/${institutionId}/detaileders/${courseInstanceId}/manageassignment`;
    return this.httpClient.post(erAssignUrl, assignERList);
  }

  getERAjaxDetails(institutionId: any, filterBy: any) {
    const params = new HttpParams().set("filterBy", filterBy);
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "detaileders/qualifications/filterData"].join('/');
    return this.httpClient.get(url, { params });
  }

  archiveOrUnarchiveEr(erEntityId: any, action: string) {
    const url = [apiEndpointURL.getInstitutionEndpoint, 'detaileders', erEntityId, action].join('/');
    const bodyContent = { updatedBy: Number(this.util.getStoredUserDetails().userId) };
    return this.httpClient.patch(url, bodyContent);
  }
}
